export { default } from './ActiveVotes';
